import LayerRenderer from './layer-renderer';
//LAZY import {fabric} from 'fabric';
import * as log from 'loglevel';
import Util from '../util';
import RenderUtil from './render-util';


class TextRenderer extends LayerRenderer {

    render(layer, context, canvas){

        let fabricText;

        // NEW: text box flag to for automatic line breaks
        if(layer.params.textBox){
            if(layer._object && layer._object.type === 'textbox'){
                fabricText = layer._object;
            } else {
                fabricText = new fabric.Textbox('', { editable: false }); // interactive text disable direct edit (text is not saved on product)
            }
        }
        // default text with manual line breaks
        else {
            // use cached object
            if(layer._object && layer._object.type === 'text'){
                fabricText = layer._object;
            } else {
                fabricText = new fabric.Text('')
            }
        }

        // text default stored in params
        let text = layer.params.text || '';
        // default params (copy to support changes without saving in editorMode config)
        let params = {
            // spread operator to make a shallow copy of the object with all the same properties
            ...layer.params
        };

        // text reference from option
        if(layer.params.option){
            let productOption = RenderUtil.getProductOption(layer.params.option, context.options);

            if(productOption){
                if(productOption.value){
                    text = productOption.value;
                }

                // store layer reference ( could be used for single layer updates - currently used to select in interactive mode )
                productOption._layer = layer;

                // flag to trigger options to render again (required to show/update the editor)
                let renderOptions = false;

                // flag to show editor below option
                if(layer.params.textEditor){

                    // _editor object with custom params style overwrite
                    if(!layer._editor){
                        // first time => init with layer default params
                        layer._editor = Util.extend({}, layer.params);
                    }

                    // store reference on option to show the editor  || editor object changed (editorMode OR multi layer reference to same option)
                    if(!productOption._editor || productOption._editor !== layer._editor){
                        productOption._editor = layer._editor;

                        // NEW: extend params eagain to support multi layer text option editor references
                        params = Util.extend(layer.params, productOption._editor);

                        renderOptions = true;
                    }

                    // back from cart restore
                    if (productOption._restoreEditor) {
                        Util.merge(productOption._editor, productOption._restoreEditor);
                        delete productOption._restoreEditor;
                        renderOptions = true;
                    }

                    params = Util.extend(layer.params, productOption._editor);

                    // NEW: LayerEditor support (moving on preview)
                    // INFO: we store the context info to use in LayerEditor
                    if (!layer._context) { // we use the context reference to check if already initialized
                        layer._context = context;
                        layer._canvas = canvas; // canvas reference (used to trigger updates on the right preview instance)
                        renderOptions = true;
                    }

                } else if(productOption._editor){
                    // reset (editorMode only)
                    delete productOption._editor;
                    // trigger options to hide the editor
                    renderOptions = true;
                }

                // trigger options to render the editor
                if(renderOptions && context.productForm){
                    context.productForm.dispatchEvent(new CustomEvent('options:render', { detail: productOption, cancelable: true, bubbles: true }));
                }

            }
        }

        // fontFamily reference from font option
        if(layer.params.optionFont){
            let productOption = RenderUtil.getProductOption(layer.params.optionFont, context.options);

            if(productOption){
                if(productOption.value){
                    // update fontFamily
                    params.fontFamily = productOption.value;
                }
            }
        }

        // color reference from color option
        if(layer.params.optionColor){
            let productOption = RenderUtil.getProductOption(layer.params.optionColor, context.options);
            let resolved = RenderUtil.resolveOptionColor(productOption);

            if(resolved){
                // update color code
                if(resolved.color){
                    params.color = resolved.color;
                }

                // NEW: text pattern img from option value  (only if no custom pattern provided)
                if(resolved.img && params.textPattern && !params.urlPattern){
                    params.urlPattern = resolved.img;
                }
            }
        }

        // NEW: text Shadow color reference from color option
        if(layer.params.textShadow && layer.params.optionTextShadowColor){
            let productOption = RenderUtil.getProductOption(layer.params.optionTextShadowColor, context.options);
            let resolved = RenderUtil.resolveOptionColor(productOption);

            if(resolved && resolved.color){
                params.textShadowColor = resolved.color;
            }
        }

        // NEW: text stroke color reference from color option
        if(layer.params.textStroke && layer.params.optionTextStrokeColor){
            let productOption = RenderUtil.getProductOption(layer.params.optionTextStrokeColor, context.options);
            let resolved = RenderUtil.resolveOptionColor(productOption);

            if(resolved && resolved.color){
                params.textStrokeColor = resolved.color;
            }
        }

        // NEW: vertical text support by adding newlines after every letter
        if(params.textVertical){
            let vertical = [];

            // split into single characters
            for (let i = 0; i < text.length; i++) {
                vertical.push(text.charAt(i));
            }

            // create newline after every character
            text = vertical.join('\n');
        }

        // get options with custom params
        let options = this._getOptions(layer, context, params);

        // explicit newline support
        options.text = text.replace(/\\n/g, '\n');

        // NEW: reset flag to recalculate the scale factor and avoid going outside of bounding box on font change or text change
        // INFO: this has to be before fabricText.set(options); - it can also cause rescaling if a text is changed and than another option is changed
        if (layer._interactiveScaled && layer._object) { // group editor copies layer without _object - avoid reset of scale
            if (
                // detect text changes (works normally during edit - but after first interactive action the scaling is skipped)
                (layer._object.text !== options.text) ||
                // detect font family change
                (layer._object.fontFamily !== options.fontFamily)
            ) {
                delete layer._interactiveScaled;
                // delete layer._interactive;  KEEP the interactive position
            }
        }

        fabricText.set(options);

        // NEW: interactive text with controls > set controls to only allow scaling in ratio
        if(options.hasControls && !RenderUtil.isEditLayer(layer, context.editorMode, context.editLayer)){
            fabricText.setControlsVisibility({mt: false, mb: false, ml: false, mr: false, bl: !options.lockScalingX, br: !options.lockScalingX, tl: !options.lockScalingY, tr: !options.lockScalingY, mtr: !options.lockRotation });
        }

        // apply auto params after options are set
        this._applyAutoParams(fabricText, layer, context, params);

        // editorMode custom reference box
        this._addRefRect(fabricText, layer, context, canvas);

        // Skip adding empty text to canvas
        if (options.text && options.text.trim()) {
            canvas.add(fabricText);
        }

        // cache reference on layer
        layer._object = fabricText;

        // NEW: pattern background promise to load pattern (currently at the bottom to avoid wrapping to code above in a promise)
        if(params.textPattern && params.urlPattern){
            return this._applyTextPattern(fabricText, layer, params);
        } else {
            return Promise.resolve(layer._object);
        }
    }

    _getOptions(layer, context, params = layer.params) {

        // NEW: custom params support for option/editor overwrite
        //let params = layer.params;

        let options = super._getOptions(layer, context, params);

        // docs: http://fabricjs.com/docs/fabric.Text.html
        options.fill = params.color || '#000000';
        options.fontSize = params.fontSize || 10;
        options.fontFamily = params.fontFamily || 'Arial';
        options.fontStyle = params.fontStyle ? params.fontStyle : 'normal';
        options.fontWeight = params.fontWeight ? params.fontWeight : 'normal';
        options.textAlign = params.textAlign ? params.textAlign : 'left';

        // NEW: line height support
        options.lineHeight = params.lineHeight ? params.lineHeight : 1.16; // fabric default 1.16

        // multiple by factor to simulate print sizes
        if(params.fontSizeFactor){
            options.fontSize *= params.fontSizeFactor;
        }

        if(params.textStroke){
            options.stroke = params.textStrokeColor ? params.textStrokeColor : '#000000';
            options.strokeWidth = params.textStrokeWidth ? params.textStrokeWidth : 1;
            options.strokeLineJoin = params.textStrokeLine ? params.textStrokeLine : 'round';
            options.strokeLineCap = params.textStrokeLine ? params.textStrokeLine : 'round';
            // always point stroke outside of text: https://github.com/fabricjs/fabric.js/issues/2378#issuecomment-451735013
            options.paintFirst =  'stroke';
        }

        options.charSpacing = params.letterSpacing ? params.letterSpacing * 100 : 0; // default 0 charSpacing in 1000 of em unit
        options.shadow = params.textShadow ? new fabric.Shadow({
            color: params.textShadowColor ? params.textShadowColor : '#000000',
            blur: params.textShadowBlur ? params.textShadowBlur : 1,
            offsetX: params.textShadowOffsetX ? params.textShadowOffsetX : 0.5,
            offsetY: params.textShadowOffsetY ? params.textShadowOffsetY : 0.5,
        }) : undefined;


        if(layer.params.textBox){
            // IMPORTANT: we only have scale setting (no manual width/height) so we map the refRect dimensions for the text box to auto wrap text
            if(RenderUtil.hasRefRect(layer) && (params.refWidth || params.refHeight)){
                options.width = params.refWidth;
                options.height = params.refHeight;
            } else {
                // full width to wrap newlines (probably rarely used but prevents new wrapMath.PIng every word because no dimensions are set)
                options.width = context.config.width;
                options.height = context.config.height;
            }
        }

        if(layer.params.textPath){

            let path = layer.params.path || '';
            let pathSide = layer.params.pathSide || 'left';

            // build circle to fill full ref dimensions
            let refDimensions = RenderUtil.getRefDimensions(layer, context);

            if(layer.params.pathShape === 'path'){
                if(path){
                    // default path
                    options.path = new fabric.Path(path, { fill: false });
                }
            } else if(layer.params.pathShape === 'circle_top'){

                // circle fixed radius based on the smaller side
                let radius = Math.min(refDimensions.width, refDimensions.height) / 2;

                path = this._describeEllipse([0, 0], [radius , radius ], [90, 359.9], 0);

                pathSide = 'left'; // auto select path side

                options.path = new fabric.Path(path, { fill: false });

                // font size top and bottom is added (strangely that increasing the width/height makes the circle path smaller)
                options.path.width += options.fontSize * 2;
                options.path.height += options.fontSize * 2;

            } else if(layer.params.pathShape === 'circle_bottom'){

                let radius = Math.min(refDimensions.width, refDimensions.height) / 2;

                path = this._describeEllipse([0, 0], [radius, radius], [270, 359.9], 0);

                pathSide = 'right'; // auto select path side

                options.path = new fabric.Path(path, { fill: false });

            } else if(layer.params.pathShape === 'ellipse_top'){

                // ellipse arc based on dimensions width/height
                path = this._describeEllipse([0, 0], [refDimensions.width / 2 , refDimensions.height / 2 ], [90, 359.9], 0);

                pathSide = 'left'; // auto select path side

                options.path = new fabric.Path(path, { fill: false });

                // font size top and bottom is added (strangely that increasing the width/height makes the circle path smaller)
                options.path.width += options.fontSize * 2;
                options.path.height += options.fontSize * 2;

            } else if(layer.params.pathShape === 'ellipse_bottom'){

                path = this._describeEllipse([0, 0], [refDimensions.width / 2, refDimensions.height / 2], [270, 359.9], 0);

                pathSide = 'right'; // auto select path side

                options.path = new fabric.Path(path, { fill: false });
            }

            if(options.path){

                // letterSpacing to add offset (text not centered anymore)
                // INFO: this causes slight bending of the letters but seems to be better than no offset -  *3 is just an approximation
                options.pathStartOffset = params.letterSpacing ? params.letterSpacing * 3 : 0;
                options.pathSide = pathSide;

                // Editor mode show the path
                if(RenderUtil.isEditLayer(layer, context.editorMode, context.editLayer) && !context.cropMode){
                    options.path.setOptions( {
                        stroke: 'rgb(178,204,255)',
                        strokeWidth: 2
                    });
                }
            }
        }

        return options;

    }

    _applyTextPattern(fabricText, layer, params) {

        // pattern cache
        if(layer._pattern && layer._pattern._url === params.urlPattern){

            fabricText.set('fill', layer._pattern);

            return Promise.resolve(layer._object);
        } else {
            return new Promise((resolve, reject) => {

                fabric.Image.fromURL(params.urlPattern, (fabricImg) => {

                    if (fabricImg === undefined) {

                        log.warn('text layer urlPattern not found: ', params.url);

                        // still resolve and not reject to continue rendering
                        resolve(null);
                        return;
                    }

                    /* custom canvas for re-scaling:  http://fabricjs.com/dynamic-patterns

                    OVERKILL: because we cannot find the true font box using fabricjs only

                    fabricImg.scaleToHeight((fabricText.height - (paddingY * 2)) / 2);

                    var patternSourceCanvas = new fabric.StaticCanvas();
                    patternSourceCanvas.add(fabricImg);

                    patternSourceCanvas.setDimensions({
                        width: fabricImg.getScaledWidth(),
                        height: fabricImg.getScaledHeight()
                    });

                    source: patternSourceCanvas.getElement(), // requires img tag
                      */

                    // cache pattern obj (reset as .fill is overwritten with color)
                    layer._pattern = new fabric.Pattern({
                        source: fabricImg._element, // requires img tag
                        repeat: 'repeat',
                        // NEW: offset (only via manual params)
                        offsetY: params.patternOffsetY || 0,
                        offsetX: params.patternOffsetX || 0,
                    });

                    // store to compare for caching
                    layer._pattern._url = params.urlPattern;

                    fabricText.set('fill', layer._pattern);

                    resolve(layer._object);

                }, { crossOrigin: 'anonymous'});
            });
        }

    }

    _degreeToRadian(degree){
        return degree * Math.PI / 180.0;
    }

    _describeEllipse([cx,cy],[rx,ry], [t1, a], r ){
        /* [
      returns a SVG path element that represent a ellipse.
      cx,cy → center of ellipse
      rx,ry → major minor radius
      t1 → start angle, in radian.
      a → angle to sweep, in radian. positive.
      r → rotation on the whole, in radian
      URL: SVG Circle Arc http://xahlee.info/js/svg_circle_arc.html
      Version 2019-06-19
       ] */
        // allow params in degree > convert to radian
        t1 = this._degreeToRadian(t1);
        a = this._degreeToRadian(a);
        r = this._degreeToRadian(r);

        const f_matrix_times = (( [[a,b], [c,d]], [x,y]) => [ a * x + b * y, c * x + d * y]);
        const f_rotate_matrix = (x => [[Math.cos(x),-Math.sin(x)], [Math.sin(x), Math.cos(x)]]);
        const f_vec_add = (([a1, a2], [b1, b2]) => [a1 + b1, a2 + b2]);
      
        a = a % (2*Math.PI);
        const rotMatrix = f_rotate_matrix (r);
        const [sX, sY] = ( f_vec_add ( f_matrix_times ( rotMatrix, [rx * Math.cos(t1), ry * Math.sin(t1)] ), [cx,cy] ) );
        const [eX, eY] = ( f_vec_add ( f_matrix_times ( rotMatrix, [rx * Math.cos(t1+a), ry * Math.sin(t1+a)] ), [cx,cy] ) );
        const fA = ( (  a > Math.PI ) ? 1 : 0 );
        const fS = ( (  a > 0 ) ? 1 : 0 );

        return "M " + sX + " " + sY + " A " + [ rx , ry , r / (2*Math.PI) *360, fA, fS, eX, eY ].join(" ");
    }
}

export default TextRenderer;
